import React from 'react';

const GoogleMapStyle = () => {
  return (
    <div className="google-map-style-1">
      <iframe
        title="KR Cable Trays Location"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1957.8882530899102!2d76.975803!3d11.055376!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8f7dfb00f5191%3A0xf6fd94f98d28281d!2sKR%20Cable%20Trays!5e0!3m2!1sen!2sin!4v1762509542284!5m2!1sen!2sin"
        alt="KR Cable Trays Location in Coimbatore industrial products manufacturing"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default GoogleMapStyle;
